import { TitlePlugin } from './index';

/**
 * Google Gemini title plugin.
 *
 * Chrome reports Gemini tabs with a generic title ("Gemini") that doesn't reflect
 * the active conversation. This plugin:
 *   1. Strips the " - Gemini" (or " – Gemini") suffix that Google appends when the
 *      page title does include the conversation name (so we store "My Chat" not
 *      "My Chat - Gemini").
 *   2. Works in tandem with the geminiTitles content script, which reads the
 *      conversation title directly from the sidebar DOM and sends it as a title
 *      override — covering the common case where Google never updates document.title
 *      at all.
 */
export const geminiPlugin: TitlePlugin = {
  name: 'gemini',
  matches: (url) => /^https:\/\/gemini\.google\.com\//.test(url),
  transform: (_url, title) => {
    const stripped = title.replace(/\s*[-\u2013]\s*Gemini\s*$/i, '').trim();
    return stripped || title;
  },
  // Chrome reports the tab title as exactly "Gemini" when no conversation name is available.
  isGeneric: (title) => /^gemini$/i.test(title.trim()),
};
